import { Box, Typography } from '@pocketlaw/tetris';
export function NoResults(props) {
    const { children } = props;
    return (<Box p="md" mb="sm">
      <Typography $appearance="100" $fontSize="small">
        {children}
      </Typography>
    </Box>);
}
